import { z } from 'zod';
const getShiftAttendanceAnalyticsResponseSchema = z.object({
    notCheckedInParticipantsCount: z.number(),
    checkedInParticipantsCount: z.number(),
    checkedOutParticipantsCount: z.number(),
});
const getShiftAttendanceAnalyticsRequestSchema = z.object({
    shiftId: z.string().uuid(),
});
export const getShiftAttendanceAnalyticsFunctionDef = {
    name: 'getShiftAttendanceAnalytics',
    requestSchema: getShiftAttendanceAnalyticsRequestSchema,
    responseSchema: getShiftAttendanceAnalyticsResponseSchema,
};
